// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CStampShare_abstract } from './../abstract/SagaSchema/CStampShare_abstract';
export class CStampShare extends CStampShare_abstract {}
